
































import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { TimelineLite } from 'gsap'

import { Meta } from '@/decorators/meta'
import Animation from '@/mixins/Animation.vue'

@Component
export default class Contact extends Mixins(Animation) {
  tl = new TimelineLite()

  @Getter('contact') contact
  @Getter('title') title

  @Meta
  metas() {
    return {
      title: 'Contact',
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  get mail() {
    return `mailto:${this.contact.mail}`
  }
}
